/**
 * JSON comes from https://www.gtlaw.com.au/designs/api/migration/services-links and
 * https://www.gtlaw.com.au/designs/api/migration/sectors-links
 * Data is copied into JSON files as fetching url leads to CORS errors locally
 */

import servicesJSON from 'src/externals/data/services.json';
import sectorsJSON from 'src/externals/data/sectors.json';

let SERVICES_DATA;
let SECTORS_DATA;

const liveURL = window.location.hostname === 'www.gtlaw.com.au';

const SECTORS_URL = 'https://www.gtlaw.com.au/designs/api/migration/sectors-links';
const SERVICES_URL = 'https://www.gtlaw.com.au/designs/api/migration/services-links';

async function fetchData() {
    if (liveURL) {
        try {
            const sectorsResponse = await fetch(SECTORS_URL);
            if (!sectorsResponse.ok) {
                throw new Error(`HTTP error! Status: ${sectorsResponse.status}`);
            }
            SECTORS_DATA = await sectorsResponse.json();
            const servicesResponse = await fetch(SERVICES_URL);
            if (!servicesResponse.ok) {
                throw new Error(`HTTP error! Status: ${servicesResponse.status}`);
            }
            SERVICES_DATA = await servicesResponse.json();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    } else {
        SECTORS_DATA = sectorsJSON;
        SERVICES_DATA = servicesJSON;
    }
}

function renderExpertiseComponent() {
    const components = document.querySelectorAll(`[data-component="profile-expertise"]`);

    if (components.length) {
        const servicesNode = document.head.querySelector(`[name="service"]`);
        const sectorsNode = document.head.querySelector(`[name="sector"]`);

        const services = servicesNode ? servicesNode.getAttribute('content').split('; ').filter(Boolean) : [];
        const sectors = sectorsNode ? sectorsNode.getAttribute('content').split('; ').filter(Boolean) : [];

        const mappedSectors = sectors.map((item) => {
            const matchedData = SECTORS_DATA.site.find((sector) => sector.name.includes(item));
            if (matchedData) {
                return {...matchedData, displayName: item};
            }
        });

        const mappedServices = services.map((item) => {
            const matchedData = SERVICES_DATA.site.find((service) => service.name.includes(item));
            if (matchedData) {
                return {...matchedData, displayName: item};
            }
        });

        components.forEach((cmp) => {
            if (services.length || sectors.length) {
                cmp.innerHTML = `<h2 class="heading-size-lg" data-funnelback="noindex">Expertise</h2>`;
            }

            // sectors
            if (mappedSectors.length) {
                const sectorContainer = document.createElement('div');
                const sectorItems = [];

                sectorContainer.classList.add('profile-expertise__item-wrapper');

                mappedSectors.forEach((sector) => {
                    sectorItems.push(`
                    <a href="${sector.url}" class="button button--filter">${sector.name}</a>
                `);
                });

                sectorContainer.innerHTML = `
                <h3 class="body-size-xxl" data-funnelback="noindex">Sectors</h3>

                <div class="profile-expertise__items">${sectorItems.join('')}</div>
            `;

                cmp.append(sectorContainer);
            }

            // services
            if (mappedServices.length) {
                const servicesContainer = document.createElement('div');
                const serviceItems = [];

                servicesContainer.classList.add('profile-expertise__item-wrapper');

                mappedServices.forEach((service) => {
                    serviceItems.push(`
                      <a href="${service.url}" class="button button--filter">${service.name}</a>
                  `);
                });

                servicesContainer.innerHTML = `
                  <h3 class="body-size-xxl" data-funnelback="noindex">Services</h3>

                  <div class="profile-expertise__items">${serviceItems.join('')}</div>
              `;

                cmp.append(servicesContainer);
            }
        });
    }
}

async function initializeExpertiseComponent() {
    await fetchData();
    renderExpertiseComponent();
}

initializeExpertiseComponent();
